// import React, { useContext } from "react";
// import { FeatureCard } from "../../../../global/components/FeatureCard/FeatureCard";
// import bgTwo from "../../../../assets/images/lockset-two1.png";
// import locksetBg from "../../../../assets/images/lockset-one.png";
// import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
// import useSWR from "swr";
// import DownloadSection from "../../../../lib/downloadSection";
// import { fetcher } from "../../../../lib/apiConstants";
// import { LoginContext } from "../../../../lib/loginContext";
// const SmartReportContent = () => {
//   const { data: products, isLoading: productsLoading } = useSWR(
//     "products/",
//     fetcher
//   );
//   const PAGE_X = "px-6 lg:px-[120px]";

//   const { isLoggedIn } = useContext(LoginContext);
//   return (
//     <>
//       <section
//         className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
//       >
//         <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1174px]">
//           Intelligent Wireless Lockset Integration        </h1>
//         <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[982px]">
//           Securely connect and manage wireless locksets with real-time communication, cloud flexibility, and edge-based reliability for seamless access control.
//         </p>
//       </section>

//       {isLoggedIn && (
//         <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 mt-4 md:mt-8 lg:mt-16">
//           <DownloadSection
//             title="Cut Sheet"
//             description="Learn about Wireless Locksets features"
//             backgroundImage={CatalogueBackground}
//             buttonText="Download Now"
//             linkField="others_link"
//             products={products || []}
//             isLoading={productsLoading}
//             filterBySlug="8dxlpl"
//             showOnlyFirst={true}
//           />
//         </div>
//       )}
//       <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-4 md:py-6 lg:py-16">
//         <FeatureCard
//           image={locksetBg}

//           label="Wireless Locksets"
//           description={`Integrated wireless locks by Schlage NDE. Add a TCIP connect Wireless BLE bridge and you can add up to 10 NDE Locksets. The bridge and locksets communicate via BLE for a wake up and respond of actions and transfer of transactions. The system allows for real time knowledge of door status and lock down. Adding NDE locks set provides a lower cost of installation for doors that may have fewr transactions and level of security. The NDE design packages the cylindrical lock, credential reader, and access control sensors together in to a small footprint that is both easy to install and affordable. NDE enables the use of both proximity (125 kHz) and/or smart (13.56 MHz) credentials which feature a much higher level of security and versatility.`}
//           imageLeft={true}
//           hideLine={true}
//         />

//         {/* Responsive two-column layout */}
//         <div className="flex flex-col lg:flex-row items-start justify-between">          {/* Text section */}
//           {/* Text section */}
//           <div className="w-full lg:w-1/2 bg-white pt-6 pr-6 md:pt-8 lg:pt-10
//   flex flex-col justify-center text-right items-end space-y-8">
//             {/* Connectivity */}
//             <div className="max-w-[520px]">
//               <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
//                 Connectivity
//               </h2>
//               <p className="text-[13px] text-[#4A4C56] leading-[21px] text-justify font-['Poppins']">
//                 Wi-Fi access point (automatic daily updates) ENGAGE™ Gateway allows
//                 real-time communication via IP to server.
//               </p>
//             </div>

//             {/* Communication Standards */}
//             <div className="max-w-[520px]">
//               <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
//                 Communication Standards
//               </h2>
//               <p className="text-[13px] text-[#4A4C56] leading-[21px] font-['Poppins']">
//                 2.4 GHz Wi-Fi (IEEE 802.11b/g), WPA2, WPA, WEP, 802.1x,
//                 Bluetooth Low Energy (v4.0), TLS 1.0, AES 256-bit.
//                 <br />
//                 Wake-Up on Radio: Responds in under 5 seconds.
//               </p>
//             </div>

//             {/* Additional */}
//             <div className="max-w-[520px]">
//               <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
//                 Additional
//               </h2>
//               <p className="text-[13px] text-[#4A4C56] leading-[21px] font-['Poppins']">
//                 Communication range up to 30 feet.
//                 <br />
//                 Data rate up to 54 Mbps.
//                 <br />
//                 Battery life up to 2 years.
//                 <br />
//                 Customer owns system and data.
//               </p>
//             </div>
//           </div>

//           {/* Image section */}
//           <div className="w-full lg:w-1/2 flex items-center justify-center ">
//             <img
//               src={bgTwo}
//               alt="Communication"
//               className="w-full h-auto max-h-[600px] object-contain "
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SmartReportContent;
import React, { useContext } from "react";
import bgTwo from "../../../../assets/images/lockset-two1.png";
import locksetBg from "../../../../assets/images/lockset-one.png";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";

const SmartReportContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const PAGE_X = "px-6 lg:px-[120px]";

  const { isLoggedIn } = useContext(LoginContext);
  return (
    <>
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1174px]">
          Intelligent Wireless Lockset Integration
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[982px]">
          Securely connect and manage wireless locksets with real-time communication, cloud flexibility, and edge-based reliability for seamless access control.
        </p>
      </section>



      <div className="w-full bg-white pt-6">

        {/* First SectionBlock — replaces FeatureCard */}
        <SectionBlock
          image={locksetBg}
          imageLeft={true}
          bgColor="#ffffff"
          imageMaxWidth="100%"
          textContent={
            <div className="w-full flex flex-col text-left items-start space-y-4 px-4 md:px-6 py-4 md:py-6">
              <h2 className="text-[15px] md:text-[19px] lg:text-[22px] font-bold text-black font-['Poppins'] leading-[150%]">
                Wireless Locksets
              </h2>
              <div className="text-[13px] text-[#2C2C2C] leading-[24px] whitespace-normal font-normal font-['Poppins']">
                Integrated wireless locks by Schlage NDE. Add a TCIP connect Wireless BLE bridge and you can add up to 10 NDE Locksets. The bridge and locksets communicate via BLE for a wake up and respond of actions and transfer of transactions. The system allows for real time knowledge of door status and lock down. Adding NDE locks set provides a lower cost of installation for doors that may have fewr transactions and level of security. The NDE design packages the cylindrical lock, credential reader, and access control sensors together in to a small footprint that is both easy to install and affordable. NDE enables the use of both proximity (125 kHz) and/or smart (13.56 MHz) credentials which feature a much higher level of security and versatility.              </div>
            </div>
          }
        />

        {/* Second SectionBlock — Connectivity / Communication Standards / Additional */}
        <SectionBlock
          image={bgTwo}
          imageLeft={false}
          bgColor="#ffffff"
          imageMaxWidth="100%"
          textContent={
            <div className="w-full flex flex-col text-right items-end space-y-8 pt-6 md:pt-8 lg:pt-10 pr-6">
              {/* Connectivity */}
              <div className="max-w-[520px]">
                <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
                  Connectivity
                </h2>
                <p className="text-[13px] text-[#4A4C56] leading-[21px] text-justify font-['Poppins']">
                  Wi-Fi access point (automatic daily updates) ENGAGE™ Gateway allows
                  real-time communication via IP to server.
                </p>
              </div>

              {/* Communication Standards */}
              <div className="max-w-[520px]">
                <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
                  Communication Standards
                </h2>
                <p className="text-[13px] text-[#4A4C56] leading-[21px] font-['Poppins']">
                  2.4 GHz Wi-Fi (IEEE 802.11b/g), WPA2, WPA, WEP, 802.1x,
                  Bluetooth Low Energy (v4.0), TLS 1.0, AES 256-bit.
                  <br />
                  Wake-Up on Radio: Responds in under 5 seconds.
                </p>
              </div>

              {/* Additional */}
              <div className="max-w-[520px]">
                <h2 className="text-[22px] text-[#121212] font-semibold leading-[30px]">
                  Additional
                </h2>
                <p className="text-[13px] text-[#4A4C56] leading-[21px] font-['Poppins']">
                  Communication range up to 30 feet.
                  <br />
                  Data rate up to 54 Mbps.
                  <br />
                  Battery life up to 2 years.
                  <br />
                  Customer owns system and data.
                </p>
              </div>
            </div>
          }
        />

      </div>
      {isLoggedIn && (
        <div className=" max-xl:max-w-full mx-auto max-xl:mx-6 mt-10 ">
          <DownloadSection
            title="Cut Sheet"
            description="Learn about Wireless Locksets features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="8dxlpl"
            showOnlyFirst={true}
          />
        </div>
      )}
    </>
  );
};

export default SmartReportContent;